import styled from 'styled-components'

import Button from '@/components/cell/molecules/Button'
import { addGaPageView, getDownloadLink, postAmplitude } from '@/core/lib'
import { useTranslation } from '@/lang'
import theme from '@/theme'
import { generateTagId } from '@/utils/test-automation'

interface Props {
  children: React.ReactNode
}

const PostList: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation()

  const handleClickDowloadButton = async () => {
    // legacy. 추후 click_download로 통합합니다. _modn
    postAmplitude('click_column_list_download_button')
    postAmplitude('click_download')

    const link = getDownloadLink(true)
    if (link.includes('javascript')) {
      location.href = link
    } else {
      window.open(link, '_blank')
    }
    addGaPageView(link)
  }

  return (
    <Wrapper>
      <ul>{props.children}</ul>

      <StyledButtonWrapper>
        <Button
          id={generateTagId('column', 'page', 'btn', 'download')}
          color="primary"
          size="large"
          onClick={handleClickDowloadButton}
        >
          {t('pages.postList.contents.downloadButton.text')}
        </Button>
      </StyledButtonWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 24px ${theme.variables.contentMargin}px;
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
`
const StyledButtonWrapper = styled.div`
  margin: 10px;
  text-align: center;
`

export default PostList
